import { render } from "./ModalContentUploader.vue?vue&type=template&id=1f2dcea6&scoped=true&lang=true"
import script from "./ModalContentUploader.vue?vue&type=script&lang=js"
export * from "./ModalContentUploader.vue?vue&type=script&lang=js"

import "./ModalContentUploader.vue?vue&type=style&index=0&id=1f2dcea6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1f2dcea6"

export default script